import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import "./Products.css";

const GCS = "https://storage.googleapis.com/rasai-nutrie-assets/products";

const categories = [
  {
    id: "tisanes",
    name: "Tisanes",
    count: 8,
    path: "/products/tisanes",
    image: `${GCS}/tisanes/banner.png`,
  },
  {
    id: "biscuits",
    name: "Biscuits",
    count: 3,
    path: "/products/biscuits",
    image: `${GCS}/biscuits/banner.jpg`,
  },
  {
    id: "coffee",
    name: "Coffee",
    count: 6,
    path: "/products/coffee",
    image: `${GCS}/coffee/banner.png`,
  },
  {
    id: "food-products",
    name: "Food Products",
    count: 8,
    path: "/products/food-products",
    image: `${GCS}/food/banner.png`,
  },
];

const Products = () => {
  const navigate = useNavigate();

  return (
    <div className="products-page">
      <div className="products-hero">
        <h1 className="products-hero-title">OUR PRODUCTS</h1>
        <p className="products-hero-sub">
          Natural. Thoughtfully formulated. Rooted in science.
        </p>
      </div>

      <div className="categories-grid">
        {categories.map((cat) => (
          <div
            key={cat.id}
            className="category-card"
            onClick={() => navigate(cat.path)}
            style={{ backgroundImage: `url(${cat.image})` }}
          >
            <div className="category-card-overlay">
              <h2 className="category-card-name">{cat.name}</h2>
              <span className="category-card-count">{cat.count} Products</span>
              <button className="category-card-btn">Explore</button>
            </div>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default Products;
